var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2507 10.0001C12.5518 10.0001 14.4173 8.1346 14.4173 5.83341C14.4173 3.53223 12.5518 1.66675 10.2507 1.66675C7.94946 1.66675 6.08398 3.53223 6.08398 5.83341C6.08398 8.1346 7.94946 10.0001 10.2507 10.0001Z",
    fill: "#D99A26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.2508 12.0833C6.0758 12.0833 2.67578 14.8833 2.67578 18.3333C2.67578 18.5666 2.85911 18.7499 3.09245 18.7499H17.4092C17.6425 18.7499 17.8258 18.5666 17.8258 18.3333C17.8258 14.8833 14.4258 12.0833 10.2508 12.0833Z",
    fill: "#D99A26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.225 17.2334L18.5917 16.6C18.925 16.1 19.1167 15.5001 19.1167 14.8584C19.1167 13.1001 17.6917 11.675 15.9333 11.675C14.175 11.675 12.75 13.1001 12.75 14.8584C12.75 16.6167 14.175 18.0417 15.9333 18.0417C16.575 18.0417 17.175 17.8501 17.675 17.5167L18.3083 18.1501C18.4333 18.2751 18.6 18.3417 18.7666 18.3417C18.9333 18.3417 19.1 18.2751 19.225 18.1501C19.4833 17.8917 19.4833 17.4834 19.225 17.2334Z",
    fill: "#D99A26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSearch);
export default __webpack_public_path__ + "static/media/user-search.00f5ffeebf88784f24ad6f1b6eb06f77.svg";
export { ForwardRef as ReactComponent };